import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../../../auth/auth.service';
import { GameControlsBase } from '../../game-controls.base';
import { ManagerService } from '../../../../../core/services/manager.service';

@Component({
  selector: 'app-game-controls-mobile-vertical',
  templateUrl: './game-controls-mobile-vertical.component.html',
  styleUrls: ['./game-controls-mobile-vertical.component.scss']
})
export class GameControlsMobileVerticalComponent extends GameControlsBase implements OnInit, DoCheck {

  @Input() showChatBox: boolean;
  @Output() gameControlsAdditionalDataOnClickOutside = new EventEmitter<void>();

  private sliderAvailable = false;
  private sliderOpen = true;

  get useNewDesign(): boolean {
    return !!this.config?.newDesign;
  }

  constructor(
    public authService: AuthService,
    public managerService: ManagerService
    ) {
    super();
  }

  ngOnInit() {
  }

  ngDoCheck() {
    const sliderAvailable = !!(this.betControls?.showBetButtons && this.betControls?.showSlider);
    if (sliderAvailable && !this.sliderAvailable) {
      this.showBetAction = this.sliderOpen;
    } else if (sliderAvailable) {
      this.sliderOpen = !!this.showBetAction;
    }
    this.sliderAvailable = sliderAvailable;
  }

  gameControlsAdditionalDataClickOutside() {
    this.gameControlsAdditionalDataOnClickOutside.emit()
  }
}
